<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2h0s4k/tc-custom/9781504065962.jpg?1703330634180" alt="This image is the cover for the book Murder in Peking"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder in Peking
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A house party in 1930s Peking is crashed by a killer in this cozy mystery by the author of <i>The Private Life of Sherlock Holmes</i>.</b></p><p>Wealthy businesswoman Kate Webber has rented out an ancient Buddhist temple in the lonely hills west of the city for what looks to be an exciting party. A worldly woman like Kate has all sorts of friends. Among her guests are a museum curator, a painter, a local teacher, an old school friend from Kansas, a debonaire mystery novelist, a travel writer, and even a Hollywood film director. The evening begins easily with smiles, cocktails, and colorful conversations. But the frivolity vanishes instantly with one piercing scream . . .</p><p>When the body of a guest is discovered in one of the bedrooms, infamous amateur detective Hope Johnson is on the scene to investigate. With his eye for detail, Johnson aims to uncover which of the other partygoers is a killer. And he better hurry before the night takes an even deadlier turn for the worse . . .</p> Murder in Peking <i>was originally published in 1937 as </i>The Laughing Buddha.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vincent Starrett
      </h2>
      
      <p class="authorDescription body article">Vincent Starrett (1886&ndash;1974) was a Chicago journalist who become one of the world&rsquo;s foremost experts on Sherlock Holmes. A books columnist for the <I>Chicago Tribune</I>, he also wrote biographies of authors such as Robert Louis Stevenson and Ambrose Bierce. A founding member of the Baker Street Irregulars, Starrett is best known for writing <I>The Private Life of Sherlock Holmes</I> (1933), an imaginative biography of the famous sleuth.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e23e998a